import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  isLogedin:boolean;
  constructor(public auth: AuthService, public router: Router) { }

  ngOnInit() {
    this.auth.currentLoginStatus.subscribe(status => this.isLogedin = status);
  }

  redirectSignup(){
    this.router.navigateByUrl('/signup');
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/home/home.component.ts